import {initPopups} from './popup';
import {initExpressCheckoutSetting, initHashedNavigationEvents} from './peachpay-settings';
import {initNavigationEvents} from './navigation';
import {initBanners} from './banner';
import {initHomepageEvents} from './dashboard';
import {initAccordionEvents} from './accordion';

function initUIEvents() {
	initPopups();
	initAccordionEvents();
	initHashedNavigationEvents();
	initNavigationEvents();
	initBanners();
	initHomepageEvents();
	initExpressCheckoutSetting();
}

export {initUIEvents};
